const scrollToTop = () => {
  const DOM = {
    triggers: document.querySelectorAll('.js-scroll-to-top'),
  };

  Array.from(DOM.triggers).forEach(trigger => {
    trigger.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  });
};

export default scrollToTop;



// WEBPACK FOOTER //
// ./src/scripts/modules/scroll-to-top.js